let awbNext = false;
let awbValue = '';
let turn_id = '';

export const setValidateAwb = (value) => {
  awbValue = value;
  if(awbValue === "" || awbValue ==="139-") {
    awbNext = false;
  } else {
    awbNext = true;
  }
}

export const validateAwb = async () => {
  if(!awbNext) {
    if(awbValue === "" || awbValue ==="139-")
    return {status: false, message:'¿Estas seguro de continuar?'}
  }

  return {status: true, message: "Coninue with the validation"}
}

export const setTurnId = (id) => {
  turn_id = id;
} 

export const getTurnId = async () => {
  return turn_id;
};